import produce from 'immer';
import { TCT_MAIN } from 'nots-window-renderer/lib/Hermesys/TCT/Constants';
import { AnyAction, Reducer } from 'redux';

import { ComposedActions } from '../../helpers/actions';

export const tctInitialState = {
  windowId: TCT_MAIN,
  phoneList: [],
  communicationList: [],
  leftTrayEntries: [],
  rightTrayEntries: [],
  statusMessage: '',
};

const updateWindowId = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { id } = payload;
    draftState.windowId = id;
  });

const updateSelectPhoneList = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { value, isSelected } = payload;
    draftState.phoneList = state.phoneList.map((item: any, index: number) =>
      index == value ? { ...item, selected: isSelected } : item
    );
  });

const addTctUsers = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.communicationList = payload.actionPayload.communicationList;
  });

const setPhoneList = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.phoneList = payload.actionPayload.phoneList;
  });

const updateTctEnableEntry = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { label, entryType, contentArea = 'left' } = payload.actionPayload;
    if (contentArea === 'left') {
      draftState.leftTrayEntries = [
        ...state.leftTrayEntries,
        { label, entryType },
      ];
    } else {
      draftState.rightTrayEntries = [
        ...state.rightTrayEntries,
        { label, entryType },
      ];
    }
  });

const addStatusMessage = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { message } = payload.actionPayload;
    draftState.statusMessage = message;
  });

const clearStatusMessage = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.statusMessage = '';
  });

const tctReducer: Reducer = (state = tctInitialState, action: AnyAction) => {
  const { type, payload } = action;
  switch (type) {
    case ComposedActions.TCTMainWindowButtonClick.uiAction:
      return updateWindowId(state, payload);
    case ComposedActions.TCTSelectPhoneListItem.uiAction:
      return updateSelectPhoneList(state, payload);
    case ComposedActions.SystemTCTAddUsers.id:
      return addTctUsers(state, payload);
    case ComposedActions.SystemTCTSetPhoneList.id:
      return setPhoneList(state, payload);
    case ComposedActions.SystemTCTEnableEntry.id:
      return updateTctEnableEntry(state, payload);
    case ComposedActions.SystemTCTShowStatusMessage.id:
      return addStatusMessage(state, payload);
    case ComposedActions.SystemTCTClearStatusMessage.id:
      return clearStatusMessage(state, payload);
    default:
      return state;
  }
};

export default tctReducer;
